import iotDeviceConfig from './iotDeviceConfig';

const isGlobalHolderCheck = (iotDevice) => getGlobalConfig(iotDevice).is_holder_check;
const isGlobalAutoStart = (iotDevice) => getGlobalConfig(iotDevice).is_autostart;
const isGlobalLedIntensity = (iotDevice) => getGlobalConfig(iotDevice).is_led_intensity;
const isGlobalAdvancedDiagnostic = (iotDevice) => getGlobalConfig(iotDevice).is_advanced_diagnostic;
const isGlobalVibration = (iotDevice) => getGlobalConfig(iotDevice).is_vibration;
const isGlobalSelfCleaning = (iotDevice) => getGlobalConfig(iotDevice).is_self_cleaning;
const isGlobalDeviceAlarm = (iotDevice) => getGlobalConfig(iotDevice).is_device_alarm;
const isGlobalStatusGestures = (iotDevice) => getGlobalConfig(iotDevice).is_status_gestures;
const isGlobalCountdown = (iotDevice) => getGlobalConfig(iotDevice).is_countdown;
const isGlobalSessionProfiling = (iotDevice) => getGlobalConfig(iotDevice).is_session_profiling;
const isGlobalVapeCloudSize = (iotDevice) => getGlobalConfig(iotDevice).is_vape_cloud_size;
const isGlobalResponsiveDraw = (iotDevice) => getGlobalConfig(iotDevice).is_responsive_draw;
const isGlobalReset = (iotDevice) => getGlobalConfig(iotDevice).is_reset;

const getGlobalConfig = (iotDevice) => iotDeviceConfig.getGlobalFeaturesConfig(iotDevice);

export default {
    isGlobalHolderCheck,
    isGlobalCountdown,
    isGlobalAutoStart,
    isGlobalDeviceAlarm,
    isGlobalLedIntensity,
    isGlobalSelfCleaning,
    isGlobalSessionProfiling,
    isGlobalStatusGestures,
    isGlobalVibration,
    isGlobalAdvancedDiagnostic,
    isGlobalVapeCloudSize,
    isGlobalResponsiveDraw,
    isGlobalReset,
};
